module.exports = __webpack_public_path__ + "static/img/2.f9cb088.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/5/zh/2.png
// module id = 2rQK
// module chunks = 0